export default {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  h3: {
    paddingLeft: 22
  },
};



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/MultiAddList/MultiAddList.css.js